// extracted by mini-css-extract-plugin
export default {"tabWp":"index_tabWp_BFcBN","tab":"index_tab_HlHC6","active":"index_active_mZlni"};